import React from "react";

import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const NotificationsActive: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="106"
      height="113"
      viewBox="0 0 106 113"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.500488 41.0942C0.500488 33.8026 1.8807 26.9797 4.64111 20.6255C7.40153 14.2713 11.1776 8.69841 15.9692 3.90674L19.2505 6.87549C14.7713 11.2505 11.2557 16.3547 8.70361 22.188C6.15153 28.0213 4.87549 34.3234 4.87549 41.0942H0.500488ZM101.126 41.0942C101.126 34.3234 99.8495 27.9953 97.2974 22.1099C94.7453 16.2244 91.2297 11.0942 86.7505 6.71924L90.0317 3.90674C94.8234 8.69841 98.5994 14.2713 101.36 20.6255C104.12 26.9797 105.5 33.8026 105.5 41.0942H101.126ZM11.1255 96.8755V92.5005H20.5005V41.2505C20.5005 33.2297 23.0786 26.1984 28.2349 20.1567C33.3911 14.1151 39.8755 10.4172 47.688 9.06299V5.93799C47.688 4.47966 48.2088 3.22966 49.2505 2.18799C50.2922 1.14632 51.5422 0.625488 53.0005 0.625488C54.4588 0.625488 55.7088 1.14632 56.7505 2.18799C57.7922 3.22966 58.313 4.47966 58.313 5.93799V9.06299C66.1255 10.4172 72.6099 14.1151 77.7661 20.1567C82.9224 26.1984 85.5005 33.2297 85.5005 41.2505V92.5005H94.8755V96.8755H11.1255ZM53.0005 112.5C50.3963 112.5 48.1828 111.589 46.3599 109.766C44.5369 107.943 43.6255 105.73 43.6255 103.125H62.3755C62.3755 105.73 61.464 107.943 59.6411 109.766C57.8182 111.589 55.6047 112.5 53.0005 112.5ZM24.8755 92.5005H81.1255V41.2505C81.1255 33.438 78.3911 26.7974 72.9224 21.3286C67.4536 15.8599 60.813 13.1255 53.0005 13.1255C45.188 13.1255 38.5474 15.8599 33.0786 21.3286C27.6099 26.7974 24.8755 33.438 24.8755 41.2505V92.5005Z"
        fill="#354052"
      />
    </SvgIcon>
  );
};

export default NotificationsActive;
